export default __webpack_public_path__ + "static/media/about.5de50f7f.jpg";